module.exports = __webpack_public_path__ + "static/media/chess-board.d9ac444b.svg";